<template>
  <div class="heatmap__popup--wrap">
    <div class="popup__content">
      <i class="icon" :class="iconClass"></i>
      <p v-if="dialogType === 'expireRedisKey'" class="title" v-html="$t(`heatmap.alert.redisTitle`)"></p>
      <p class="message" v-html="$t(`heatmap.alert.${dialogType}`)"></p>

      <template v-if="dialogType === 'expireRedisKey'">
        <ui-button @click="$emit('onCloseClick')" class="left">
          {{ $t('common.cancel') }}
        </ui-button>

        <ui-button :primary="true" @click="$emit('onTargetRefresh')">
          {{ $t('common.refresh') }}
        </ui-button>
      </template>
      <template v-else>
        <ui-button @click="$emit('onCloseClick')">
          {{ $t('heatmap.alert.button.confirm') }}
        </ui-button>
      </template>

    </div>
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'HeatmapPopup',
  components: {
    UiButton
  },
  props: {
    dialogType: {
      type: String,
      required: true
    }
  },
  computed: {
    iconClass () {
      switch (this.dialogType) {
        case 'includeNoStreamDate':
        case 'noStreamDisplay':
          return 'icon--not-empty-warning'
        case 'noStreamByDate':
        case 'noStreamEventIncludeNoStreamDate':
          return 'icon--empty-warning'
        case 'expireRedisKey':
          return 'icon--warning-red-polygon'
        default:
          return 'icon--heatmap-popup'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .heatmap__popup--wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    width: 430px;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    padding-bottom: 25px;
    text-align: center;

    .popup__content {
      padding: 0 50px;
    }

    i {
      display: block;
      margin: 50px auto 0;
    }

    .title {
      margin-top: 12px;
      color: #444;
      text-align: center;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
    }

    .message {
      margin-top: 12px;
      font-size: 14px;
      line-height: 1.43;
      text-align: center;
      color: #2f2f2f;
    }

    button {
      margin-top: 50px;
      margin-left: 5px;
      &.left {
        margin-left: 10px;
      }
    }
  }
</style>
